export const logAnalyticsEvent = (eventType, eventProperties = {}) => {
  // push to GTM which will trigger a log to Amplitude
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "logEvent",
    eventType,
    eventProperties,
  })
}

export const logAnalyticsPageView = (
  geoType,
  careType,
  registered,
  pageType,
) => {
  // push to GTM which will trigger a virtual page view in GA
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "logPageView",
    geoType,
    careType,
    registered,
    pageType,
  })
}

export const logAnalytics = (amplitudeData, googleAnalyticsData) => {
  logAnalyticsEvent(amplitudeData.eventType, amplitudeData.eventProperties)
  logAnalyticsPageView(
    googleAnalyticsData.geoType,
    googleAnalyticsData.careType,
    googleAnalyticsData.registered,
    googleAnalyticsData.pageType,
  )

  if (window.analytics && window.analytics.page) {
    // Track pageview to new page with Segment
    window.analytics.page()
  }
}
